function copyShareLink() {
    event.preventDefault();
    var shareInput = document.querySelector('input#share-input');
    shareInput.select();
    document.execCommand('copy');
}